import React from 'react';
import CrudLayoutContainer from 'src/components/crud-layout-component/CrudLayoutContainer';
import { DATE_TIME_FORMAT } from 'src/constants/CommonConstants';
import { UnAuthorizedErrorPage } from 'src/utils/CommonUtils';
import RoutingUtil from 'src/utils/RoutingUtil';
import SearchContainerWithPermission from '../search-container/SearchContainerWithPermission';
import { companyEditAction, companySearchAction } from './actions/CompanyActions';
import CompanyFrom from './CompanyFrom';

const data = [
    {
        title: 'Manage',
        link: RoutingUtil.companyManagerUrl(),
        component: CompanyFrom,
    },
    {
        title: 'Search',
        link: RoutingUtil.companySearch(),
        component: () => (
            <SearchContainerWithPermission
                scope="master.company_manager.search"
                editScope="master.company_manager.search.edit"
                fallback={<UnAuthorizedErrorPage />}
                reducer="CompanyReducer"
                dataPath="search"
                editAction={companyEditAction}
                redirectUrlOnEdit={RoutingUtil.companyManagerUrl()}
                action={companySearchAction}
                columns={{
                    companyName: {
                        display: 'Company Name',
                    },
                    companyDisplayName: {
                        display: 'Display Name',
                    },
                    companyType: {
                        display: 'Company Type',
                    },
                    cin: {
                        display: 'CIN',
                    },
                    llpn: {
                        display: 'LLPN',
                    },
                    pan: {
                        display: 'PAN',
                    },
                    gstin: {
                        display: 'GSTIN',
                    },
                    email: {
                        display: 'Email',
                    },
                    phone: {
                        display: 'Phone',
                    },
                    authorizedPersonId: {
                        display: 'Authorized Person',
                        path: 'authorizedPersonId.personalInfo.firstName',
                    },
                    active: {
                        display: 'Active',
                    },
                    by: {
                        display: 'By',
                        path: 'by.personalInfo.firstName',
                    },
                    updatedBy: {
                        display: 'Updated By',
                        path: 'updatedBy.personalInfo.firstName',
                    },
                    ts: {
                        display: 'Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                    updatedTs: {
                        display: 'Updated Ts',
                        type: Date,
                        format: DATE_TIME_FORMAT.TIMEAGO,
                    },
                }}
            />
        ),
    },
];

const CompanyContainer = () => (
    <CrudLayoutContainer
        title="Company Manager"
        tabs={data}
        routes={data}
    />
);

CompanyContainer.propTypes = {

};

export default CompanyContainer;
